export default "__VITE_ASSET__BKNm4eAZ__"